import React, { useState } from 'react'

import Button from '@mui/material/Button'
import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import Grid from '@mui/material/Grid'
import { Typography } from '@mui/material'

const VersionDetails = () => {
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Button onClick={handleOpen}>
        v{`${process.env.REACT_APP_VERSION}`} 6-13-22
      </Button>
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle>Version Notes</DialogTitle>
        <Grid container sx={{ px: 2 }}>
          <Grid item>
            <Typography sx={{ px: 2, fontWeight: 'bold' }}>
              v1.01 6-13-22
            </Typography>
            <ul style={{ marginTop: 0 }}>
              <li>Super Mid Wet & Super Mid Dry</li>
              <ul>
                <li>
                  "Didn't Startup" checkbox added to all "Last On Product" boxes
                </li>
              </ul>
              <li>Super Mid Wet</li>
              <ul>
                <li>
                  "Last Flush" and "Last On Product" added to both churn
                  sections
                </li>
              </ul>
              <li>Super Mid Dry</li>
              <ul>
                <li>
                  Powder Silo Products now have a "Buttermilk" option on the
                  dropdown
                </li>
              </ul>
            </ul>
          </Grid>
          <Grid item>
            <Typography sx={{ px: 2, fontWeight: 'bold' }}>
              v1.00 6-7-22
            </Typography>
            <ul style={{ marginTop: 0 }}>
              <li>
                Moved Supervisor and Vacation Relief Passdowns to
                SUPERconnection
              </li>
              <li>
                Updated Supervisor Passdown to facilitate a "Wet" and "Dry" side
              </li>
              <li>
                In order to email a Supervisor Passdown the following must be
                true
              </li>
              <ul>
                <li>
                  "Date Shift Started" are the same for both the Wet and Dry
                  side forms
                </li>
                <li>"Shift" is the same for both the Wet and Dry side forms</li>
                <li>"Name" is not empty for both the Wet and Dry side forms</li>
              </ul>
              <li>
                The "Name" field is automatically filled in when a Passdown form
                is saved and automatically cleared once a Passdown email has
                been sent
              </li>
            </ul>
          </Grid>
        </Grid>
        <Typography sx={{ p: 2 }}>
          If you notice any bugs, errors, or have suggestions for improvement
          please email them to me at:{' '}
          <a href='mailto:coakes@highdesertmilk.com'>
            coakes@highdesertmilk.com
          </a>{' '}
          Thanks, Cody Oakes
        </Typography>
      </Dialog>
    </>
  )
}

export default VersionDetails
